import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { contractGeneratorOperations, contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import Select from 'ViatoUi/Web/FormElements/Selects/Select';

const Type = ({ option, optionId, productId, type, isSetupFee }) => {
	const dispatch = useDispatch();
	const { t } = useTranslation('contractGenerator');

	const translationPath = 'layouts.share.modals.createLink.linkSettings.setting.type';

	const dataToSubmit = useSelector(contractGeneratorSelectors.getDiscountDataToSubmit);
	const defaultValue = isSetupFee ? option.setupFee.discount.type : option.discount.type;
	const objectPath = `${type}.${productId}.${optionId}.${isSetupFee ? 'setupFee.' : ''}discount.type`;
	const value = get(dataToSubmit, objectPath, defaultValue);

	const setDataToSubmit = data => {
		let preparedData = data;
		if (isSetupFee) {
			preparedData = { setupFee: data };
		}
		dispatch(
			contractGeneratorOperations.setDiscountDataToSubmit({
				[type]: {
					[productId]: {
						[optionId]: preparedData
					}
				}
			})
		);
	};

	return (
		<Select
			label={isSetupFee ? t(`${translationPath}.setup`) : t(`${translationPath}.monthly`)}
			options={[
				{ label: t(`${translationPath}.percent`), value: 'percentage' },
				{ label: t(`${translationPath}.cent`), value: 'cent' }
			]}
			value={value}
			onChange={newValue => setDataToSubmit({ discount: { type: newValue.value } })}
		/>
	);
};

Type.propTypes = {
	isSetupFee: PropTypes.bool.isRequired,
	option: PropTypes.object.isRequired,
	optionId: PropTypes.number.isRequired,
	productId: PropTypes.number.isRequired,
	type: PropTypes.oneOf(['products', 'extensions']).isRequired
};

export default Type;
